module.exports = __webpack_public_path__ + "static/media/6.cc056c57.jpg";